import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogContent, IconButton } from "@mui/material";
import closeButton from "../../Assets/popup-close.svg";
//import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateController/WorkflowTemplateservice";

const EventConfirmPopup = ({ openConfirmationPopup, onClose, handleCancel, handleSave, handleDeleteSave, isLoading, popupData }) => {

  const handleClose = () => onClose();
  var Spinner = require('react-spinkit');
  return (
    <Dialog
      open={openConfirmationPopup}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Adjust the opacity here
        },
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
          }}
        >
          <p>{popupData?.title}</p>
          <IconButton onClick={handleClose}>
            <img src={closeButton} alt="close-button" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {

          popupData?.name

        }

        <div className="saveTemplate-button">
          <Button
            variant="contained"
            style={{ backgroundColor: popupData.popupType === "publish" ? "#02ACF6" : '#02ACF6', textTransform: 'capitalize', height: '37px', width: 'auto' }}
            onClick={() => {
              if (popupData?.popupType !== "Ok") {
                handleSave(); // run your cancel logic
              } else {
                // optionally do nothing or close popup silently
                handleClose();
              }
            }}
            className="dialog-save-button"
          >
            {popupData?.popupType}
          </Button>
          {popupData?.popupType !== "Ok" && (
            <Button
              variant="contained"
              style={{ backgroundColor: "#757ea5", textTransform: "none" }}
              onClick={handleCancel}
              className="dialog-save-button"
            >
              {popupData?.title == "Version" ? "Discard" : "Cancel"}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EventConfirmPopup;
